var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 134,
    viewBox: "0 0 162 134",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37109 61.6272V62.9928",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30469 62.3662L4.4205 63.5148",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 65.4247H3.57775",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17578 68.5358L4.2916 67.3872",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37109 68.9098V67.5443",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64862 67.9992L7.73828 67.0889",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4671 65.7231H9.10156",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55878 62.5376L8.64844 63.4479",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6562 2V2.91034",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9219 4.73055H77.8322",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6562 7.46161V6.55127",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9299 4.73055H81.0195",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 40.2341V41.5996",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 44.3309H24.1233",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 47.9715V46.606",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4944 44.3309H29.1289",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.829 89.8656C125.917 89.8656 126.799 90.7481 126.799 91.8361C126.799 92.9246 125.917 93.8066 124.829 93.8066C123.742 93.8066 122.859 92.9246 122.859 91.8361",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.848 71.9884C135.017 71.6235 136.81 70.193 137.225 68.6539C137.602 70.0144 139.179 71.6235 140.603 71.7453C139.001 72.3127 137.468 73.9983 137.225 75.3225C137.06 73.9728 134.941 72.1851 133.848 71.9884Z",
    fill: "#C7C7C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7773 89.2576C14.3624 89.0752 15.2585 88.3601 15.466 87.5905C15.6542 88.2704 16.4429 89.0752 17.1547 89.1362C16.3536 89.4195 15.5877 90.2626 15.466 90.9247C15.3833 90.2498 14.3237 89.3558 13.7773 89.2576Z",
    fill: "#C7C7C7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6332 25.9402C24.6332 26.7844 23.9492 27.4681 23.1056 27.4681C22.2617 27.4681 21.5781 26.7844 21.5781 25.9402C21.5781 25.0965 22.2617 24.4123 23.1056 24.4123C23.9492 24.4123 24.6332 25.0965 24.6332 25.9402Z",
    fill: "#909090"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.634 30.0431C126.634 31.4535 125.49 32.5968 124.081 32.5968C122.67 32.5968 121.527 31.4535 121.527 30.0431C121.527 28.6327 122.67 27.4893 124.081 27.4893C125.49 27.4893 126.634 28.6327 126.634 30.0431Z",
    fill: "#C7C7C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.999 23.1241C161.999 24.243 161.093 25.1498 159.974 25.1498C158.856 25.1498 157.949 24.243 157.949 23.1241C157.949 22.0051 158.856 21.0983 159.974 21.0983C161.093 21.0983 161.999 22.0051 161.999 23.1241Z",
    fill: "#C7C7C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.182 117.735C53.182 118.441 52.6105 119.012 51.9053 119.012C51.2004 119.012 50.6289 118.441 50.6289 117.735C50.6289 117.03 51.2004 116.458 51.9053 116.458C52.6105 116.458 53.182 117.03 53.182 117.735Z",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4222 16.1252C52.4222 16.9693 51.7383 17.6531 50.8947 17.6531C50.0512 17.6531 49.3672 16.9693 49.3672 16.1252C49.3672 15.2814 50.0512 14.5972 50.8947 14.5972C51.7383 14.5972 52.4222 15.2814 52.4222 16.1252Z",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3882 131.876C90.4121 132.247 89.3197 131.757 88.9483 130.781C88.577 129.804 89.067 128.711 90.0435 128.34C91.0192 127.969 92.1116 128.459 92.4829 129.435C92.8547 130.412 92.3643 131.504 91.3882 131.876Z",
    stroke: "#00665A",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8029 95.7646H53.4769C50.8497 95.7646 48.6992 93.6077 48.6992 90.9717V37.743C48.6992 35.1069 50.8497 32.9512 53.4769 32.9512H90.8029C93.4312 32.9512 95.5817 35.1069 95.5817 37.743V90.9717C95.5817 93.6077 93.4312 95.7646 90.8029 95.7646Z",
    fill: "#C7C7C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6193 98.0407H50.2933C47.6661 98.0407 45.5156 95.8839 45.5156 93.2479V40.0191C45.5156 37.3831 47.6661 35.2273 50.2933 35.2273H87.6193C90.2476 35.2273 92.3981 37.3831 92.3981 40.0191V93.2479C92.3981 95.8839 90.2476 98.0407 87.6193 98.0407Z",
    fill: "#E8EBF2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5189 99.8373H47.1157C44.4831 99.8373 42.3281 97.6894 42.3281 95.0643V42.0559C42.3281 39.4308 44.4831 37.284 47.1157 37.284H84.5189C87.1526 37.284 89.3075 39.4308 89.3075 42.0559V95.0643C89.3075 97.6894 87.1526 99.8373 84.5189 99.8373Z",
    fill: "#5A5A5A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5189 99.8373H47.1157C44.4831 99.8373 42.3281 97.6894 42.3281 95.0643V42.0559C42.3281 39.4308 44.4831 37.284 47.1157 37.284H84.5189C87.1526 37.284 89.3075 39.4308 89.3075 42.0559V95.0643C89.3075 97.6894 87.1526 99.8373 84.5189 99.8373Z",
    fill: "#EEEEEE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 53.435H51.5012C50.7122 53.435 50.0664 52.8206 50.0664 52.07C50.0664 51.3184 50.7122 50.704 51.5012 50.704H79.128C79.917 50.704 80.5628 51.3184 80.5628 52.07C80.5628 52.8206 79.917 53.435 79.128 53.435Z",
    fill: "#C7C7C7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 61.6272H51.5012C50.7122 61.6272 50.0664 61.0128 50.0664 60.2622C50.0664 59.5106 50.7122 58.8962 51.5012 58.8962H79.128C79.917 58.8962 80.5628 59.5106 80.5628 60.2622C80.5628 61.0128 79.917 61.6272 79.128 61.6272Z",
    fill: "#C7C7C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 69.8199H51.5012C50.7122 69.8199 50.0664 69.2055 50.0664 68.4549C50.0664 67.7043 50.7122 67.0889 51.5012 67.0889H79.128C79.917 67.0889 80.5628 67.7043 80.5628 68.4549C80.5628 69.2055 79.917 69.8199 79.128 69.8199Z",
    fill: "#C7C7C7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 78.0131H51.5012C50.7122 78.0131 50.0664 77.3987 50.0664 76.6481C50.0664 75.8965 50.7122 75.2821 51.5012 75.2821H79.128C79.917 75.2821 80.5628 75.8965 80.5628 76.6481C80.5628 77.3987 79.917 78.0131 79.128 78.0131Z",
    fill: "#C7C7C7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9219 86.2069H51.5073C50.715 86.2069 50.0664 85.5925 50.0664 84.8419C50.0664 84.0903 50.715 83.4759 51.5073 83.4759H65.9219C66.7143 83.4759 67.3629 84.0903 67.3629 84.8419C67.3629 85.5925 66.7143 86.2069 65.9219 86.2069Z",
    fill: "#C7C7C7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.015 75.6172C89.4908 81.1405 80.9386 81.7636 74.7297 77.4992C73.9362 76.9445 73.181 76.3214 72.4767 75.6172C72.1141 75.2558 71.7724 74.8829 71.4504 74.4903C70.8063 73.7062 70.2422 72.87 69.78 72.006C68.9657 70.5467 68.412 68.9983 68.1096 67.3977C67.1343 62.3782 68.5927 56.9753 72.4767 53.0931C76.37 49.1993 81.7737 47.7505 86.7941 48.7164C88.3938 49.0279 89.9437 49.5815 91.4033 50.3865C92.2686 50.859 93.0933 51.423 93.8787 52.067C94.2702 52.3878 94.6432 52.7306 95.0046 53.0931C95.7101 53.7973 96.3425 54.5512 96.887 55.3457C101.153 61.5524 100.529 70.1043 95.015 75.6172Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.47 74.5305C87.7228 80.2788 78.4089 80.2777 72.6606 74.5305C66.9198 68.7896 66.9198 59.4747 72.6681 53.7275C78.4089 47.9866 87.7228 47.9866 93.4636 53.7275C99.2109 59.4747 99.2109 68.7896 93.47 74.5305ZM96.4195 50.7741C89.0424 43.397 77.0881 43.397 69.711 50.7741C62.335 58.1501 62.3286 70.112 69.7046 77.4891C76.4186 84.201 86.942 84.8063 94.3437 79.2954C95.0667 78.7564 95.7629 78.1521 96.427 77.4891C97.0901 76.8249 97.6943 76.1287 98.2322 75.4058C103.743 68.003 103.132 57.4871 96.4195 50.7741Z",
    fill: "#00665A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.453 105.296L125.143 105.606C123.094 107.656 119.739 107.656 117.689 105.606L98.7695 86.6871L106.534 78.9231L125.453 97.8421C127.503 99.8921 127.503 103.246 125.453 105.296Z",
    fill: "url(#paint0_linear_978_36386)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6398 74.8268L104.23 80.4174L100.261 84.3853L94.6719 78.7947C95.4096 78.2447 96.1189 77.6281 96.7977 76.9515C97.4743 76.2749 98.0909 75.5645 98.6398 74.8268Z",
    fill: "#00665A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.17 97.6098L117.455 105.323L116.066 103.933L123.78 96.2199L125.17 97.6098Z",
    fill: "#00FFE0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.963 79.1912L99.037 87.1172L97.8594 85.9397L105.785 78.0138L106.963 79.1912Z",
    fill: "#00CCB3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6644 51.749L70.227 71.1854C69.495 69.8734 68.9973 68.4813 68.7266 67.0424L85.5212 50.2476C86.9592 50.5287 88.3524 51.0253 89.6644 51.749Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0381 56.3692L75.0242 76.1926C74.2716 75.6972 73.5554 75.1396 72.8874 74.5094C72.5436 74.185 72.2184 73.8524 71.9141 73.501L93.1839 53.4341C93.5563 53.7222 93.9101 54.029 94.2528 54.3534C94.9208 54.9835 95.5217 55.6582 96.0381 56.3692Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_978_36386",
    x1: 151.732,
    y1: 141.087,
    x2: 90.5074,
    y2: 131.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BFA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSearch);
export default __webpack_public_path__ + "static/media/bankSearch.0bd8840449accd73c4b35781721700db.svg";
export { ForwardRef as ReactComponent };